import * as types from '../constants/ActionTypes';

export const preserveFilterFieldData = formData => ({
  type: types.PRESERVE_FILTER_FIELD_DATA,
  payload: formData,
});

export const preserveData = responseData => (dispatch) => {
  dispatch(preserveFilterFieldData(responseData));
};



// WEBPACK FOOTER //
// ./contactUs/actions/action-search-filters.js